// ── Gap-fill translations ────────────────────────────────────────────────────
// Keys used by features shipped AFTER the main dict was authored (the save-to-
// library button, the paywall pricing lines, the source disclosure, and the
// landing platform-preview cards). Merged in dict.ts at lower priority than
// the main table, so anything translated there wins; this only fills holes.
// Arabic uses the left-pointing arrow where English uses →.

import type { UIDict } from './dict';

export const PAGE_TRANSLATIONS: Record<string, UIDict> = {
  en: {
    'article.save': 'Save to your library',
    'article.unsave': 'Remove from your library',
    'article.per_month_start': '/month to start',
    'article.unlock_now': 'Unlock every story',
    'article.compare_tiers': 'Compare membership tiers →',
    'article.source_label': 'Source',
    'article.source_disclosure': 'This briefing draws on the original reporting below:',
    'article.from_5_cancel': 'From $5/month · cancel anytime',
    'landing.pv_concierge_k': 'Concierge',
    'landing.pv_concierge_v': 'White-glove access',
    'landing.pv_events_k': 'Summits & Events',
    'landing.pv_events_v': 'Where Africa connects',
    'landing.pv_travel_k': 'Business Travel',
    'landing.pv_travel_v': 'Beyond the boardroom',
    'landing.pv_hubs_k': 'Country Hubs',
    'landing.pv_hubs_v': 'Every nation, in depth',
    'landing.pv_intel_k': 'Market Intelligence',
    'landing.pv_intel_v': 'Data with real context',
  },
  fr: {
    'article.save': 'Enregistrer dans votre bibliothèque',
    'article.unsave': 'Retirer de votre bibliothèque',
    'article.per_month_start': '/mois pour commencer',
    'article.unlock_now': 'Débloquer tous les récits',
    'article.compare_tiers': "Comparer les formules d'adhésion →",
    'article.source_label': 'Source',
    'article.source_disclosure': "Ce briefing s'appuie sur le reportage original ci-dessous :",
    'article.from_5_cancel': 'Dès 5 $/mois · annulable à tout moment',
    'landing.pv_concierge_k': 'Conciergerie',
    'landing.pv_concierge_v': 'Un accompagnement sur mesure',
    'landing.pv_events_k': 'Sommets et événements',
    'landing.pv_events_v': "Là où l'Afrique se connecte",
    'landing.pv_travel_k': "Voyages d'affaires",
    'landing.pv_travel_v': 'Au-delà des salles de réunion',
    'landing.pv_hubs_k': 'Hubs pays',
    'landing.pv_hubs_v': 'Chaque nation, en profondeur',
    'landing.pv_intel_k': 'Intelligence de marché',
    'landing.pv_intel_v': 'Des données avec du vrai contexte',
  },
  pt: {
    'article.save': 'Guardar na sua biblioteca',
    'article.unsave': 'Remover da sua biblioteca',
    'article.per_month_start': '/mês para começar',
    'article.unlock_now': 'Desbloquear todas as histórias',
    'article.compare_tiers': 'Comparar planos de adesão →',
    'article.source_label': 'Fonte',
    'article.source_disclosure': 'Este briefing baseia-se na reportagem original abaixo:',
    'article.from_5_cancel': 'A partir de 5 $/mês · cancele quando quiser',
    'landing.pv_concierge_k': 'Concierge',
    'landing.pv_concierge_v': 'Acompanhamento personalizado',
    'landing.pv_events_k': 'Cimeiras e eventos',
    'landing.pv_events_v': 'Onde a África se conecta',
    'landing.pv_travel_k': 'Viagens de negócios',
    'landing.pv_travel_v': 'Para além das salas de reunião',
    'landing.pv_hubs_k': 'Hubs de países',
    'landing.pv_hubs_v': 'Cada nação, em profundidade',
    'landing.pv_intel_k': 'Inteligência de mercado',
    'landing.pv_intel_v': 'Dados com contexto real',
  },
  ar: {
    'article.save': 'احفظ في مكتبتك',
    'article.unsave': 'أزل من مكتبتك',
    'article.per_month_start': '/شهرياً للبدء',
    'article.unlock_now': 'افتح كل القصص',
    'article.compare_tiers': 'قارن باقات العضوية ←',
    'article.source_label': 'المصدر',
    'article.source_disclosure': 'يستند هذا الموجز إلى التقرير الأصلي أدناه:',
    'article.from_5_cancel': 'من 5$ شهرياً · إلغاء في أي وقت',
    'landing.pv_concierge_k': 'الكونسيرج',
    'landing.pv_concierge_v': 'خدمة راقية شخصية',
    'landing.pv_events_k': 'القمم والفعاليات',
    'landing.pv_events_v': 'حيث تلتقي أفريقيا',
    'landing.pv_travel_k': 'سفر الأعمال',
    'landing.pv_travel_v': 'أبعد من قاعات الاجتماعات',
    'landing.pv_hubs_k': 'مراكز الدول',
    'landing.pv_hubs_v': 'كل دولة، بعمق',
    'landing.pv_intel_k': 'معلومات السوق',
    'landing.pv_intel_v': 'بيانات بسياق حقيقي',
  },
};
